//----------------------------------------------- 
export module PlegmaStatics {
  export namespace Constants {
    export const HierarchySeparator: string = "/";
  }
  export namespace NodePairingConstants {
    export const s_GetTokensRequest: string = "gettokensreq";
    export const s_GetKeysRequest: string = "getkeysreq";
    export const s_TokensResponse: string = "tokensrsp";
    export const s_KeysResponse: string = "keysrsp";
  }
  export namespace PlegmaAPI {
    export const APIVersion: number = 1;
    export const KeySeparator: string = "-";
    export const s_LoginReq: string = "loginreq";
    export const s_LoginRsp: string = "loginrsp";
    export const s_NodeInfoReq: string = "nodeinforeq";
    export const s_NodeInfoRsp: string = "nodeinforsp";
    export const s_NodeUnpairedReq: string = "nodeunpairedreq";
    export const s_ThingsGet: string = "thingsget";
    export const s_ThingsSet: string = "thingsset";
    export const s_PortEventMsg: string = "porteventmsg";
    export const s_PortStateGet: string = "portstateget";
    export const s_PortStateSet: string = "portstateset";
    export const s_ActivePortKeysMsg: string = "activeportkeysmsg";
    export const s_GenericRsp: string = "genericrsp";
  }
}